$(function () {
    const $logo = $('#header-logo');
    const $button = $('#header-burger');
    const $menu = $('#header-burger-menu');
    const scrollTriggerValue = $logo.data('scroll-trigger');
    const $scroll1 = $('.slider');
    const $scroll2 = $('.slider2');
    const $accordion = $(".accordion");
    const $formSubscribe = $("#form_subscribe");
    const $buttonSubscribe = $("#submitBtn");
    const burger = '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="1" y="5.3559" width="15" height="1"/>' +
        '<rect x="1" y="8.3559" width="15" height="1"/>' +
        '<rect x="1" y="11.3559" width="15" height="1"/>' +
        '</svg>';

    /**
     * menu
     */
    $(document).on('click', '#header-burger-menu-close', function (e) {
        e.stopPropagation();
        $('#header-burger').removeClass('expanded').html(burger);
    });

    $button.on('click', function () {
        $(this).addClass('expanded').html($menu.html());
    });

    $button.on('mouseleave', function () {
        $(this).removeClass('expanded').html(burger);
    });

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > scrollTriggerValue) {
            $logo.addClass('scrolled');

        } else {
            $logo.removeClass('scrolled');
        }
    });

    /**
     * accordion
     */
    $accordion.click(function () {
        $(this).toggleClass("active");
        let panel = $(this).next(".accordion__panel");
        panel.slideToggle(200);
    });

    /**
     * docs more button
     */
    $(document).on('click', '.load-more-btn', function () {
        var btn = $(this);
        var componentId = btn.data('component-id');
        var container = $('#docs-list-' + componentId);
        var page = btn.data('page');
        var params = btn.data('params');

        BX.showWait(container[0]);

        $.ajax({
            url: window.location.href,
            type: 'POST',
            data: {
                page: page,
                component_id: componentId,
                ajax: 'Y'
            },
            success: function (data) {
                BX.closeWait(container[0]);

                // Новые элементы для конкретного компонента
                var $data = $(data);
                var docsItems = $data.find('#docs-list-' + componentId + ' .docs-item');
                container.append(docsItems);

                // Наличие кнопки "загрузить еще" для конкретного компонента
                var newBtn = $data.find('button[data-component-id="' + componentId + '"]');
                if (newBtn.length) {
                    btn.data('page', page + 1);
                } else {
                    btn.parent().remove();
                }
            },
            error: function () {
                BX.closeWait(container[0]);
                alert('Произошла ошибка при загрузке данных');
            }
        });
    });

    /**
     * subscribe
     */
    window.onCaptchaSuccess = function (token) {
        $formSubscribe.trigger('submit');
    };

    $buttonSubscribe.on("click", function () {
        window.smartCaptcha.execute();
    });

    $formSubscribe.submit(function (e) {
        e.preventDefault();

        // Очищаем предыдущие ошибки
        $('.error-message').remove();
        $('.alert-success').remove();

        // Сбор данных из формы
        let formData = {
            sessid: $("#sessid").val(),
            token: $("input[name='smart-token']").val(),
            fonds: [],
            email: $("#email").val(),
            soglasie: $("#soglasie").is(":checked") ? 1 : 0
        };

        console.log('Post data:', formData)

        // Собираем выбранные checkbox
        $("input[name='fonds']:checked").each(function () {
            formData.fonds.push($(this).val());
        });

        $.ajax({
            url: '/ajax/subscribe.php',
            type: 'POST',
            data: formData,
            dataType: 'json',
            success: function (response) {
                if (response.status === 'success') {
                    $formSubscribe.before(
                        '<div class="alert alert-success">На Ваш Email адрес было отправлено письмо для подтверждения</div>'
                    );
                    window.smartCaptcha.reset();
                } else {
                    $formSubscribe.before(
                        '<div class="alert alert-danger error-message">' + response.message + '</div>'
                    );
                    window.smartCaptcha.reset();
                }
            },
            error: function () {
                $formSubscribe.before(
                    '<div class="alert alert-danger error-message">Произошла ошибка при отправке данных!</div>'
                );
                window.smartCaptcha.reset();
            }
        });
    });

    /**
     * scroll
     */
    $scroll1.scrollbar("before");
    $scroll2.scrollbar("after");
});